import React from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import "./StickyCTABar.css";

const StickyCTABar = () => (
  <div className="sticky-cta-bar">
    <a href="https://wa.me/919392014678?text=Hi!%20I%20want%20a%20website%20for%20my%20business" className="sticky-cta-wa" target="_blank" rel="noopener noreferrer">
      <FaWhatsapp /> WhatsApp
    </a>
    <Link to="/get-started" className="sticky-cta-quote" onClick={() => window.scrollTo(0, 0)}>
      Get Free Quote
    </Link>
  </div>
);

export default StickyCTABar;
